
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/silence-is-strength",
      function () {
        return require("private-next-pages/articles/silence-is-strength.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/silence-is-strength"])
      });
    }
  